import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import MultientryTable from './MultientryTable'
import { Box } from '@chakra-ui/react';

const MUltientry = () => {
    return (
        <div>
            <HeaderSection
                title="Voucher Multi Entry"
                breadcrumb={["Dashboard", "Voucher"]}
            />

            <Box p={6}>

                <MultientryTable />
            </Box>
        </div>
    )
}

export default MUltientry